import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "px-4 pt-4" }, "Dateien", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "px-4 pt-4" }, "Unterlagen", -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

import {ref} from 'vue';
import ErrorDisplay from '@/components/ErrorDisplay.vue';
import Loading from '@/components/Loading.vue';
import ApiDownload from '@/components/ApiDownload.vue';
import Provider from '@/model/Provider';
import {getProviderDocuments} from '@/api/module/provider';
import {useRoute} from 'vue-router';
import ApiDownloadItem from '@/components/ApiDownloadItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerDocuments',
  setup(__props, { expose: __expose }) {

const route = useRoute();

const data = ref<Pick<
  Provider,
  | 'Dateien'
  | 'Unterlagen'
  | 'KundStatus'
  | 'Kundname'
  | 'KundenNr'
  | 'icon'
  | 'color'
  | 'GroupName'
> | null>(null);

const loading = ref(true);
const error = ref<Error | null>(null);

async function fetchData() {
  loading.value = true;
  const temp = await getProviderDocuments({
    KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id),
  });
  loading.value = false;
  data.value = temp[0];
  if (!temp[0]) {
    error.value = new Error('Etwas ist schief gelaufen, versuchen Sie es später');
  }
}

fetchData();

__expose({
  fetchData, error, loading, data,
  ErrorDisplay,
  Loading,
  ApiDownload,
});

return (_ctx: any,_cache: any) => {
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (!loading.value && !error.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (data.value?.Dateien?.Values.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_v_list, { lines: "two" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value?.Dateien.Values, (file) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: file.DownloadToken
                    }, [
                      _createVNode(ApiDownloadItem, {
                        "file-name": file.Dateiname,
                        token: file.DownloadToken,
                        title: file.Dateiname.replaceAll('_', ' '),
                        elevation: 1
                      }, null, 8, ["file-name", "token", "title"])
                    ]))
                  }), 128))
                ], undefined, true),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (data.value?.Unterlagen?.Values.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value?.Unterlagen.Values, (item) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: item.Bezeichnung
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { class: "mb-2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.Bezeichnung), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Seiten, (page) => {
                              return (_openBlock(), _createBlock(_component_v_col, {
                                cols: "6",
                                key: page.DownloadToken
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(ApiDownload, {
                                    key: page.Seite,
                                    title: `Seite ${page.Seite}`,
                                    token: page.DownloadToken,
                                    "file-name": `${page.Seite.toString()}.jpg`
                                  }, null, 8, ["title", "token", "file-name"]))
                                ], undefined, true),
                                _: 2
                              }, 1024))
                            }), 128))
                          ], undefined, true),
                          _: 2
                        }, 1024)
                      ], undefined, true),
                      _: 2
                    }, 1024))
                  }), 128))
                ], undefined, true),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (!data.value?.Unterlagen?.Values.length && !data.value?.Dateien?.Values.length)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 2,
              class: "mb-0 text-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Es sind keine Dokumente vorhanden ")
              ], undefined, true),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_btn, {
          position: "fixed",
          icon: "",
          class: "ma-3",
          location: "right bottom",
          to: { name: 'customer_document_create' },
          color: "primary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [
                _createTextVNode("mdi-plus")
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ]))
    : (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (error.value)
            ? (_openBlock(), _createBlock(ErrorDisplay, {
                key: 0,
                message: error.value.message,
                loading: loading.value,
                onRetry: fetchData
              }, null, 8, ["message", "loading"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(Loading)
        ]))
}
}

})